import { ErrorFallback } from '@components/ErrorFallback/ErrorFallback';
import { BookingError } from 'config/datadog';
import useAnalytics from 'hooks/useAnalytics';
import useError from 'hooks/useError';
import usePayload from 'hooks/usePayload';
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { RenderElement } from 'types/components';

const GlobalErrorBoundary = ({ children }: { children: RenderElement }) => {
  const { payloadError } = usePayload();
  const { setError } = useError();
  const { logError } = useAnalytics();

  useEffect(() => {
    if (!payloadError) return;

    logError(BookingError.UNABLE_TO_RETRIEVE_JWT_OR_LOUNGE);
    setError({ message: payloadError as string });
  }, [payloadError]);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
